<template>
    <div>
        <v-container style="max-width: 1300px !important">
            <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 1rem !important;">
                <v-system-bar class="py-5 px-3 system-bar-title" dark>
                    Periodos
                </v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5 elevation-1"
                style="margin-bottom: 2rem !important;padding: 2rem .6rem 0 .6rem;">
                <v-row>
                    <v-col cols="12" lg="3" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchPeriodo" label="Periodo"
                            append-icon="mdi-magnify" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="3" md="2">
                        <el-button type="primary" @click="dialogEdit = true">Nuevo</el-button>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="mx-auto my-5" style=" margin:0 auto;padding: 1.5rem;">
                <div>
                    <v-data-table :headers="filteredHeaders" :items="filteredData" :loading="isLoading" dense
                        loading-text="Cargando... Por favor espere" style="margin: 0 auto;">
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip top color="yellow">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2 custom-btn" fab dark @click="openEdit(item)" color="yellow"
                                        v-bind="attrs" v-on="on">
                                        <v-icon class="custom-icon" dark>
                                            mdi mdi-account-edit
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Editar</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:[`item.estado`]="{ item }">
                            <span :class="item.estado ? 'activo' : 'desactivado'">
                                {{ item.estado ? 'Activo' : 'Desactivado' }}
                            </span>
                        </template>

                    </v-data-table>
                </div>
            </v-card>
            <el-dialog :title="titleForm" :visible.sync="dialogEdit">
                    <el-form :model="periodosForm" label-position="top" :rules="rules" ref="periodosForm">
                        <v-row>
                            <v-col cols="12" sm="4">
                                <el-form-item label="Año" :label-width="formLabelWidth" prop="year">
                                    <el-date-picker v-model="periodosForm.year" type="year" placeholder="Año"
                                        @change="loadPeriodoInput" format="yyyy" value-format="yyyy">
                                    </el-date-picker>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <el-form-item label="Mes" :label-width="formLabelWidth" prop="mes">
                                    <el-select v-model="periodosForm.mes" filterable placeholder="Mes"
                                        style="width: 100%;" @change="loadPeriodoInput">
                                        <el-option v-for="item in arrayMeses" :key="item.value" :label="item.label"
                                            :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </v-col>
                        </v-row>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="closeEdit">Cancelar</el-button>
                        <el-button type="primary" @click="submitForm('periodosForm')"
                            v-if="!statusEdit">Confirmar</el-button>
                        <el-button type="primary" @click="editForm('periodosForm')"
                            v-if="statusEdit">Guardar</el-button>
                    </span>
                </el-dialog>
            <v-dialog v-model="dialogLoader" persistent width="300"
                style="padding: 1rem;overflow: hidden !important;background: white !important;">
                <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
            </v-dialog>
            <el-dialog :title="titleForm" :visible.sync="dialogDiasPeriodo" persistent width="300"  @closed="destruirComponenteDias" @open="abrirComponenteDias">
                <DiasPorPeriodo  v-if="mostrarDias" :periodoActual="periodoActual"></DiasPorPeriodo>
            </el-dialog>
        </v-container>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import DiasPorPeriodo from "../dias/index.vue"
import Swal from "sweetalert2";
export default {
    data() {
        return {
            mostrarDias:true,
            periodoActual:null,
            dialogDiasPeriodo:false,
            arrayMeses: [
                { label: 'Enero', value: '01' },
                { label: 'Febrero', value: '02' },
                { label: 'Marzo', value: '03' },
                { label: 'Abril', value: '04' },
                { label: 'Mayo', value: '05' },
                { label: 'Junio', value: '06' },
                { label: 'Julio', value: '07' },
                { label: 'Agosto', value: '08' },
                { label: 'Setiembre', value: '09' },
                { label: 'Octubre', value: '10' },
                { label: 'Noviembre', value: '11' },
                { label: 'Diciembre', value: '12' }

            ],
            rules: {
                mes: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ],
                year: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ]
            },
            titleForm: 'Nuevo Periodo',
            formLabelWidth: '70px',
            valid: true,
            idHorario: null,
            titleButton: 'Guardar',
            periodosForm: {
                mes: null,
                year: null,
                periodo: null
            },
            searchSala: [],
            statusEdit: false,
            modal: false,
            searchPeriodo: null,
            searchNombreCompleto: null,
            searchCargo: null,
            searchCondIngreso: null,
            dialogImport: false,
            dialogLoader: false,
            ver: false,
            searchDocumento: "",
            dataPaciente: [],
            date1: new Date()
                .toISOString()
                .substr(0, 10),
            search: "",
            sortBy: [{ key: "cupos_disponible", order: "asc" }],
            headers: [
                { text: "Periodo", value: "periodo" },
                { text: "Mes", value: "mes" },
                { text: "Año", value: "year" },
                { text: "Acciones", value: "actions", align: "right" }
            ],
            dialogEdit: false,
            dialogDelete: false,
            isLoading: false,
            dataArray: [],
            arrayAreas: [],
            arrayRoles: [],
            dataUsuariosHisar: [],
            arrayFeriados: []
        };
    },
    watch: {
        dialogEdit(newVal, oldVal) {
            if (newVal) {
                console.log("El diálogo se abrió.asda");
            } else {
                this.periodoActual=null;
            }
        },
        dialogDiasPeriodo(newVal, oldVal) {
            if (newVal) {
                console.log("El diálogo se abrió.");
            } else {
                
            }
        },
    },
    methods: {
        destruirComponenteDias() {
            this.mostrarDias = false; // desmonta el componente
        },
        abrirComponenteDias(){
            this.mostrarDias = true;
        },
        loadPeriodoInput() {
            this.periodosForm.periodo = `${this.periodosForm.year}-${this.periodosForm.mes}`
        },
        editForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.edit();
                } else {
                    return false;
                }
            });
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.save();
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        clearForm() {
            this.periodosForm = {
                mes: null,
                year: null,
                periodo: null
            }
        },
        openEdit(item) {
            this.titleForm = 'Periodo: ' + item.periodo;
            this.periodoActual=item.periodo;
            this.statusEdit = true;
            this.idHorario = item.id;
            this.dialogDiasPeriodo=true;
            this.periodosForm.mes = item.mes;
            this.periodosForm.year = item.year;
            this.periodosForm.periodo = item.periodo;
        },
        closeEdit() {
            this.resetForm('periodosForm');
            this.statusEdit = false;
            this.dialogEdit = false;
            this.titleForm = 'Nuevo Periodo',
            this.clearForm();
        },
        saveDiasDelMes(dias) {
            const candidadDias = dias;
            for (let index = 0; index < candidadDias.length; index++) {
                const element = candidadDias[index];
                axios
                    .post(RUTA_API + "/rrhh_planilla_dias/", element)
                    .then((res) => {
                        if (candidadDias.length == index + 1) {
                            Swal.fire({
                                title: "¡Exito!",
                                text: "El periodo se generó con exito.",
                                icon: "success",
                                draggable: true
                            });
                            this.dataInit();
                            this.dialogLoader = false;
                        }
                    })
                    .catch((res) => {
                        this.dialogEdit = false;
                        console.log("Error:", res);
                        this.dialogLoader = false;
                    });
            }
        },
        obtenerFeriadosPorMes(idPeriodo, year, mes) {
            axios
                .get("https://calendarific.com/api/v2/holidays?&api_key=ohOuQwpIWaHExK84YVukM9Hq2ZqGXI3H&country=PE&year=" + year + "&month=" + mes)
                .then((res) => {
                    const response = res.data.response.holidays;
                    this.arrayFeriados = response.map(holiday => holiday.date.datetime.day);
                    this.obtenerDiasDelMes(parseInt(year), parseInt(mes) - 1, idPeriodo);
                })
                .catch((res) => {

                });

        },
        obtenerDiasDelMes(year, month, idPeriodo) {
            const dias = [];
            const nombresDias = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

            // month en JavaScript es 0-indexado (enero = 0, diciembre = 11)
            const ultimoDia = new Date(year, month + 1, 0).getDate();

            for (let dia = 1; dia <= ultimoDia; dia++) {
                const fecha = new Date(year, month, dia);
                const nombreDia = nombresDias[fecha.getDay()];
                dias.push({
                    periodo_id: idPeriodo,
                    numero_dia: dia,
                    nombre_dia: nombreDia,
                    es_feriado: nombreDia === 'Domingo' || this.arrayFeriados.includes(dia) ? true : false
                });
            }
            this.saveDiasDelMes(dias);
        },
        save() {
            this.dialogLoader = true;
            const year = this.periodosForm.year;
            const mes = this.periodosForm.mes;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/rrhh_planilla_periodos/", this.periodosForm, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.closeEdit();
                            const idPeriodo = res.data.id;
                            this.obtenerFeriadosPorMes(idPeriodo, year, mes);
                        })
                        .catch((res) => {
                            Swal.fire({
                                title: "¡Error!",
                                text: "El periodo no se generó.",
                                icon: "error",
                                draggable: true
                            });
                            this.dataInit();
                            this.closeEdit();
                            this.dialogLoader = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        edit() {
            this.dialogLoader = true;
            this.statusEdit = true;
            this.dialogEdit = false;
            axios
                .put(RUTA_API + "/rrhh_planilla_periodos/" + this.idHorario + "/", this.periodosForm)
                .then((res) => {
                    Swal.fire({
                        title: "¡Exito!",
                        text: "El periodo se editó con exito.",
                        icon: "success",
                        draggable: true
                    });
                    this.dataInit();
                    this.dialogLoader = false;
                    this.statusEdit = false;
                })
                .catch((res) => {
                    console.log("Error:", res);
                });

        },
        dataInit() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/rrhh_planilla_periodos/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dialogLoader = false;
                            this.dataPaciente = res.data;
                        })
                        .catch((res) => {
                            this.dialogLoader = false;
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    this.dialogLoader = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
    },
    mounted() { },
    computed: {
        filteredHeaders() {
            return this.headers;
        },
        filteredData() {
            if (!this.searchPeriodo) {
                return this.dataPaciente;
            }
            let filtered = this.dataPaciente;
            if (this.searchPeriodo) {
                filtered = filtered.filter((item) => {
                    const nombreCompleto = item.periodo;
                    return nombreCompleto.toLowerCase().includes(this.searchPeriodo.toLowerCase());
                });
            }
            return filtered;
        },
    },
    created() {
        this.dataInit();
    },
    components: {
        DiasPorPeriodo
    },
};
</script>
<style scoped>
::v-deep .el-dialog {
    width: 65%;
    margin-top: 8% !important;
    margin-bottom: 3% !important;
}
.el-form-item__label {
    line-height: 0px !important;
}

.activo {
    color: rgb(255, 255, 255);
    background: #74d467;
    padding: 0.2rem .7rem;
    border-radius: .4rem;
    font-size: 12px;
}

.desactivado {
    color: rgb(255, 255, 255);
    background: #df4141;
    padding: 0.2rem .7rem;
    border-radius: .4rem;
    font-size: 12px;
}

::v-deep .theme--dark.v-system-bar {
    color: hsl(0, 0%, 100%) !important;
}

.layout-loading {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 202;
    background: #e3e3e3b1;
}

::v-deep .v-dialog {
    display: flex;
    justify-content: center;
    box-shadow: none;
    overflow-y: hidden !important;
}

.system-bar-title {
    display: flex;
    justify-content: space-between;
    color: white;
    padding: 1.2rem 1.4rem !important;
}

::v-deep tr th {
    text-wrap: nowrap !important;
}

::v-deep .v-card {
    box-shadow: 0px 0px 11px 6px rgb(15 61 99 / 27%) !important;
}

::v-deep tr td {
    text-wrap: nowrap !important;
}

::v-deep .theme--dark.v-system-bar {
    background: #1780cd;
}

.custom-btn {
    width: 25px !important;
    height: 25px !important;
}

.custom-icon {
    font-size: 20px !important;
}

.bg-primary-table {
    font-weight: 400;
}

.text-start {
    font-size: 0.8rem !important;
}

.container {
    max-width: 3000px !important;
}

td {
    white-space: nowrap;
}
</style>